// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"4bfa36cc","264":"4847b1ef","453":"e493eccd","581":"342396d1","639":"2b7c8c36"}[chunkId] + ".chunk.js";
};